// confirmPlugin.js
import { createApp, h } from "vue";
import AlertDialog from "@/components/AlertDialog.vue";
import { vuetify } from "./vuetify";

export default {
	install(app) {
		app.config.globalProperties.$alert = function (message, title = "") {
			return new Promise((resolve) => {
				const confirmApp = createApp({
					data() {
						return { isVisible: true, title, message };
					},
					methods: {
						onCancel() {
							resolve(false);
							this.closeDialog();
						},
						closeDialog() {
							console.log("closeDialog");
							resolve(true);
							this.isVisible = false;
							setTimeout(() => confirmApp.unmount(), 0);
						},
					},
					render() {
						return this.isVisible
							? h(AlertDialog, {
									title: this.title,
									message: this.message,
									isVisible: this.isVisible,
									onCancel: this.onCancel,
							  })
							: null;
					},
				});

				// Vuetifyをプラグインとして追加
				confirmApp.use(vuetify);

				const container = document.createElement("div");
				document.body.appendChild(container);
				confirmApp.mount(container);
			});
		};
	},
};
